import api from "./api";

interface UpdateWorkspaceParams {
  name: string;
  description: string;
}

export interface UpdateWorkspaceProps {
  id: string;
  name: string;
  description: string;
}

export async function updateWorkspace(props: UpdateWorkspaceProps) {
  const { id, name, description } = props;
  const params: UpdateWorkspaceParams = {
    name,
    description,
  }; 
  const res = await api.put<unknown>(`/workspace/${id}`, params);
  return res.data;
}
